// This file contains URLs and secrets to be used in dev environment
// DO NOT COMMIT TO REPOSITORY

export const Manifest = {
    services: {
        dragonFruit: 'https://api.internal.logixboard.com',
    },
}
